import { InputAdornment, TextField as MuiTextField } from "@mui/material"
import { TextFieldProps } from "@/types/components/textField"

import classnames from "classnames"

import "./textField.scss"

// min rows, multiline 프롭을 사용하면 텍스트에러리어로 사용할 수 있음
export default function TextField({
  showMessage,
  appendIcon,
  prependIcon,
  label,
  multiline,
  ...props
}: TextFieldProps) {
  return (
    <div
      className={classnames("TextFieldCont", props.className, {
        fullWidth: props.fullWidth,
        multiline,
      })}>
      {label && <p className="text-field-label">{label}</p>}
      <MuiTextField
        {...props}
        multiline={multiline}
        variant="outlined"
        InputProps={{
          ...props.InputProps,
          startAdornment: prependIcon && (
            <InputAdornment position="start">{prependIcon}</InputAdornment>
          ),
          endAdornment: appendIcon && <InputAdornment position="end">{appendIcon}</InputAdornment>,
        }}
      />

      {showMessage && (
        <p
          className={classnames("text-field-message", {
            error: props.error,
          })}>
          {props.message}
        </p>
      )}
    </div>
  )
}
